import { Alert, Box, FormControlLabel, Stack, Switch, TextField, Typography } from "@mui/material";
import {
  DYNAMIC_EXPLAINER_TEXT,
  DYNAMIC_NO_INPUTS_TEXT,
  DYNAMIC_NOT_BTM_TEXT,
  DYNAMIC_TITLE,
  NEGATIVE_PRICES_HELPER_TEXT,
  NEGATIVE_PRICES_LABEL,
  REGULATED_CHARGES_HELPER_TEXT,
  REGULATED_CHARGES_LABEL,
  SUPPLIER_FEE_HELPER_TEXT,
  SUPPLIER_FEE_LABEL,
  validateDynamicTariff,
} from "./config/dynamicTariff";

// The Tariffs tab under the Dynamic scheme: the two per-kWh prices and the
// negative-price rule replace the monthly table and the peak hours.
export default function DynamicTariffFields({ tariffs, setTariffs, isBtm }) {
  const block = tariffs?.dynamic || {};
  const errors = validateDynamicTariff(tariffs);
  const blank = (v) => v === "" || v === null || v === undefined;
  const onNumber = (key) => (e) => {
    const raw = e.target.value.replace(",", ".");
    if (!/^\d*\.?\d*$/.test(raw)) return;
    setTariffs(`dynamic.${key}`, raw);
  };
  return (
    <Box>
      <Typography variant="body2" sx={{ fontWeight: 700, mb: 1 }}>
        {DYNAMIC_TITLE}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {DYNAMIC_EXPLAINER_TEXT}
      </Typography>
      {!isBtm ? (
        <Alert severity="warning" sx={{ mb: 2 }}>
          {DYNAMIC_NOT_BTM_TEXT}
        </Alert>
      ) : null}
      <Stack spacing={2}>
        <TextField
          label={SUPPLIER_FEE_LABEL}
          value={block.supplierFeeEurKwh ?? ""}
          onChange={onNumber("supplierFeeEurKwh")}
          error={Boolean(errors.supplierFeeEurKwh)}
          helperText={errors.supplierFeeEurKwh || SUPPLIER_FEE_HELPER_TEXT}
          inputProps={{ inputMode: "decimal" }}
          InputLabelProps={{ shrink: true }}
          size="small"
          fullWidth
        />
        <TextField
          label={REGULATED_CHARGES_LABEL}
          value={block.regulatedEurKwh ?? ""}
          onChange={onNumber("regulatedEurKwh")}
          error={Boolean(errors.regulatedEurKwh)}
          helperText={errors.regulatedEurKwh || REGULATED_CHARGES_HELPER_TEXT}
          inputProps={{ inputMode: "decimal" }}
          InputLabelProps={{ shrink: true }}
          size="small"
          fullWidth
        />
        <Box>
          <FormControlLabel
            control={
              <Switch
                checked={Boolean(block.passNegativePrices)}
                onChange={(e) => setTariffs("dynamic.passNegativePrices", e.target.checked)}
              />
            }
            label={NEGATIVE_PRICES_LABEL}
          />
          <Typography variant="caption" color="text.secondary" sx={{ display: "block", ml: 6 }}>
            {NEGATIVE_PRICES_HELPER_TEXT}
          </Typography>
        </Box>
        {isBtm && blank(block.supplierFeeEurKwh) && blank(block.regulatedEurKwh) ? (
          <Alert severity="warning">{DYNAMIC_NO_INPUTS_TEXT}</Alert>
        ) : null}
      </Stack>
    </Box>
  );
}
